import React, { useState } from 'react';
import { db } from '../firebase';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { useTranslation } from 'react-i18next';

const StayRequestButton = ({ bookingKey, roomNumber, hotelId }) => {
    const { t, i18n } = useTranslation();
    const [selectedDate, setSelectedDate] = useState(new Date().toISOString().substring(0, 10)); 
    const [selectedTime, setSelectedTime] = useState('10:00'); 
    const [requestType, setRequestType] = useState(null); 
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');

    const handleSubmitRequest = async (type) => {
        if (!bookingKey || !roomNumber || !hotelId) {
            setMessage(t('stay_mod.err_missing'));
            return;
        }
        if (!selectedDate || !selectedTime) {
              setMessage(t('stay_mod.err_datetime'));
              return;
        }

        setRequestType(type);
        setLoading(true);
        setMessage('');

        // Format for display and storage (using current locale)
        const readableDate = new Date(selectedDate).toLocaleDateString(i18n.language, {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        });

        // Translate the type for the message
        const translatedType = t(`stay_mod.${type}`);

        try {
            await addDoc(collection(db, 'requests'), {
                type: type, 
                guestId: bookingKey, 
                bookingKey: bookingKey,
                roomNumber: roomNumber,
                requestedDate: selectedDate,
                isPending: true,
                requestedTime: selectedTime, 
                hotelId: hotelId,
                guestMessage: `Request for ${translatedType.toLowerCase()} on ${readableDate} at ${selectedTime}`,
                createdAt: serverTimestamp(),
            });
            
            setMessage(t('stay_mod.msg_success', { type: translatedType, date: readableDate, time: selectedTime }));
        } catch (error) {
            console.error("Error submitting request:", error);
            setMessage(t('requests.msg_error'));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{ marginTop: '20px', padding: '15px', border: '1px solid #ccc', borderRadius: '5px' }}>
            <h3>{t('stay_mod.title')}</h3>
            
            <div style={{ marginBottom: '15px', display: 'flex', gap: '15px' }}>
                <div>
                    <label htmlFor="requestDate" style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
                        {t('registration.section1_date')}:
                    </label>
                    <input
                        id="requestDate"
                        type="date"
                        value={selectedDate}
                        onChange={(e) => setSelectedDate(e.target.value)}
                        style={{ padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }}
                    />
                </div>
                <div>
                    <label htmlFor="requestTime" style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
                        {t('stay_mod.label_time')}:
                    </label>
                    <input
                        id="requestTime"
                        type="time"
                        value={selectedTime}
                        onChange={(e) => setSelectedTime(e.target.value)}
                        style={{ padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }}
                    />
                </div>
            </div>
            
            <p style={{ color: message.includes('Error') || message.includes('Failed') || message.includes('Erreur') ? 'red' : 'green' }}>
                {message}
            </p>
            
            <button 
                onClick={() => handleSubmitRequest('earlyCheckIn')} 
                disabled={loading || !selectedDate || !selectedTime}
                style={{ backgroundColor: '#007bff', color: 'white', padding: '10px', marginRight: '10px', border: 'none', borderRadius: '4px', cursor: 'pointer' }}
            >
                {loading && requestType === 'earlyCheckIn' ? t('checker.searching') : t('stay_mod.btn_early')}
            </button>
            <button 
                onClick={() => handleSubmitRequest('lateCheckOut')} 
                disabled={loading || !selectedDate || !selectedTime}
                style={{ backgroundColor: '#6c757d', color: 'white', padding: '10px', border: 'none', borderRadius: '4px', cursor: 'pointer' }}
            >
                {loading && requestType === 'lateCheckOut' ? t('checker.searching') : t('stay_mod.btn_late')}
            </button>
        </div>
    );
};

export default StayRequestButton;